<div class="buttons">
  <button *ngFor="let button of buttons"
          type="button"
          (click)="buttonPressingOccured(button.id)"
          class="{{getButtonStyle(button)}}"
          [class.disabled]="isDisabled(button)">
    {{button.text}}
  </button>
</div>
